export const light = {
    libretto: {
        bgCanvas: '#F5F6F7',
        bgSurface: '#FFFFFF',
        bgSubtle: '#F3F4F6',
        borderSubtle: '#E5E7EB',
        borderMuted: '#D1D5DB',
        textPrimary: '#1A1A1A',
        textMuted: '#6B7280',
        textSubtle: '#9CA3AF',
        iconPrimary: '#4B5563',
    },
    alternate: {
        main: '#f7faff',
        dark: '#edf1f7',
    },
    cardShadow: 'rgba(23, 70, 161, .11)',
    mode: 'light',
    primary: {
        main: '#2B6BFD',
        light: '#467de3',
        dark: '#2f6ad9',
        contrastText: '#ffffff',
    },
    secondary: {
        light: '#ffb74d',
        main: '#f9b934',
        dark: '#FF9800',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
        primary: '#1e2022',
        secondary: '#8B8C90',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
        paper: '#FFFFFF',
        default: '#F5F6F7',
        level2: '#F3F4F6',
        level1: '#FFFFFF',
    },
};

export const dark = {
    libretto: {
        bgCanvas: '#121418',
        bgSurface: '#1A1D23',
        bgSubtle: '#232833',
        borderSubtle: '#313845',
        borderMuted: '#3C4554',
        textPrimary: '#F5F7FA',
        textMuted: '#A7B0BC',
        textSubtle: '#8C97A6',
        iconPrimary: '#A7B0BC',
    },
    alternate: {
        main: '#1a2138',
        dark: '#151a30',
    },
    cardShadow: 'rgba(0, 0, 0, .11)',
    common: {
        black: '#000',
        white: '#fff',
    },
    mode: 'dark',
    primary: {
        main: '#2B6BFD',
        light: '#2196f3',
        dark: '#1E4FC4',
        contrastText: '#FFFFFF',
    },
    secondary: {
        light: '#FFEA41',
        main: '#FFE102',
        dark: '#DBBE01',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
        primary: '#F5F7FA',
        secondary: '#A7B0BC',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#1A1D23',
        default: '#121418',
        level2: '#232833',
        level1: '#1A1D23',
    },
};
